import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField, FormControl, InputLabel, MenuItem, Select
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  fetchDoctorsList,
  trashDoctor,
  editDoctor,
  updateDoctor, fetchSpecialtiesList, reorderDoctors
} from "../../Adapters/ApiAdapter";
import ReactQuill from "react-quill";
import { baseImage_path, baseUrl } from "../../variables/Variables";
import RestoreDoctors from "./RestoreDoctors";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";

import {
  DndContext,
  closestCenter,
  useSensor,
  useSensors,
  PointerSensor, useDroppable
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import CKEditorField from "../../components/CKEditorField";

const ListDoctors = () => {
  const [doctors, setDoctors] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [editDoctorItem, setEditDoctorItem] = useState(null);
  const [deleteDoctorId, setDeleteDoctorId] = useState(null);
  const [loadingAction, setLoadingAction] = useState(false);
  const [specialtyOptions, setSpecialtyOptions] = useState([]);
  const [topDoctors, setTopDoctors] = useState([]);
  const [allDoctors, setAllDoctors] = useState([]);

  useEffect(() => {
    const fetchSpecialties = async () => {
      try {
        const response = await fetchSpecialtiesList();
        setSpecialtyOptions(response.specialities || []);
      } catch (error) {
        toast.error("Failed to fetch specialties.");
      }
    };

    fetchSpecialties();
  }, []);

  // Fetch doctors list
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await fetchDoctorsList();
  //       setDoctors(
  //         [...(response.data || [])].sort((a, b) => b.id - a.id)
  //       );
  //       // drag drop doctors
  //       setTopDoctors(
  //         [...(response.data || [])]
  //           .filter((doc) => doc.display_order && doc.display_order <= 20)
  //           .sort((a, b) => a.display_order - b.display_order)
  //       );
  //     } catch (err) {
  //       toast.error("Failed to fetch doctors list.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchDoctorsList();
        const allDoctors = response.data || [];

        setDoctors([...allDoctors].sort((a, b) => b.id - a.id));

        // Extract Top 20 doctors based on display_order
        const topTen = [...allDoctors]
          .filter((doc) => doc.display_order && doc.display_order <= 20)
          .sort((a, b) => a.display_order - b.display_order);

        setTopDoctors(topTen);
      } catch (err) {
        toast.error("Failed to fetch doctors list.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const fetchAllDoctors = async () => {
    try {
      const res = await fetchDoctorsList(); // adjust to your API call
      if (res?.data) {
        const sorted = res.data.sort((a, b) => a.name.localeCompare(b.name));
        setAllDoctors(sorted);
      }
    } catch (err) {
      toast.error("Failed to load doctors list");
    }
  };

  useEffect(() => {
    fetchAllDoctors();
  }, []);

  const remainingDoctors = doctors.filter(
    (doc) => !topDoctors.some((top) => top.id === doc.id)
  );

  const SortableRow = ({ doctor, onRemove }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: doctor.id });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      padding: "10px",
      borderBottom: "1px solid #ccc",
      backgroundColor: "#f5f5f5",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "move"
    };

    return (
      <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
        <span>{doctor.name}</span>
        {onRemove && (
          <Button size="small" onClick={() => onRemove(doctor.id)} color="error">
            Remove
          </Button>
        )}
      </div>
    );
  };

  const sensors = useSensors(useSensor(PointerSensor));

  // const handleDragEnd = async (event) => {
  //   const { active, over } = event;

  //   if (!over || active.id === over.id) return;

  //   const activeDoctor = doctors.find((d) => d.id === active.id);
  //   const overDoctor = doctors.find((d) => d.id === over.id);

  //   const activeInTop = topDoctors.find((d) => d.id === active.id);
  //   const overInTop = topDoctors.find((d) => d.id === over.id);

  //   if (!activeDoctor || !overDoctor) {
  //     toast.error("Doctor not found");
  //     return;
  //   }

  //   if (!activeInTop && overInTop) {
  //     if (topDoctors.length >= 20) {
  //       toast.warning("Only 20 doctors allowed in Top 20");
  //       return;
  //     }

  //     const insertIndex = topDoctors.findIndex((d) => d.id === over.id);
  //     const draggedDoctor = { ...activeDoctor };
  //     const updatedTop = [...topDoctors];
  //     updatedTop.splice(insertIndex, 0, draggedDoctor);
  //     // setTopDoctors(updatedTop);

  //     const reorderedWithDisplayOrder = updatedTop.map((doc, index) => ({
  //       ...doc,
  //       display_order: index + 1
  //     }));

  //     setTopDoctors(reorderedWithDisplayOrder);

  //     try {
  //       await reorderDoctors({
  //         from_id: activeDoctor.id,  // ✅ main id
  //         to_id: overDoctor.id       // ✅ main id
  //       });
  //       toast.success("Doctor moved to Top 20");
  //     } catch {
  //       toast.error("Failed to update order");
  //     }
  //   }
  //   else if (activeInTop && overInTop) {
  //     const oldIndex = topDoctors.findIndex((d) => d.id === active.id);
  //     const newIndex = topDoctors.findIndex((d) => d.id === over.id);
  //     const reordered = arrayMove(topDoctors, oldIndex, newIndex);
  //     setTopDoctors(reordered);

  //     try {
  //       await reorderDoctors({
  //         from_id: activeDoctor.id,  // ✅ main id
  //         to_id: overDoctor.id       // ✅ main id
  //       });
  //       toast.success("Top 20 order updated");
  //     } catch {
  //       toast.error("Failed to reorder doctors");
  //     }
  //   }
  // };

  const containers = {
    TOP: 'topDoctors',
    ALL: 'allDoctors'
  };

  const { setNodeRef } = useDroppable({ id: "top-doctors" });
  const { setNodeRef: setAllNodeRef } = useDroppable({ id: "all-doctors" });

  const handleDragEnd = async ({ active, over }) => {
    if (!over || active.id === over.id) return;

    const activeId = active.id;
    const overId = over.id;

    const activeDoctor = allDoctors.find(d => d.id === activeId) || topDoctors.find(d => d.id === activeId);
    const overDoctor = topDoctors.find(d => d.id === overId);

    const isActiveInTop = topDoctors.some(d => d.id === activeId);
    const isOverInTop = topDoctors.some(d => d.id === overId);

    try {
      if (!isActiveInTop && isOverInTop) {
        // Move from All → Top 20
        let updatedTop = [...topDoctors];
        const insertIndex = topDoctors.findIndex(d => d.id === overId);
        updatedTop.splice(insertIndex, 0, { ...activeDoctor });

        if (updatedTop.length > 20) {
          const removed = updatedTop.pop();
          setAllDoctors(prev =>
            [...prev, removed].sort((a, b) => a.name.localeCompare(b.name))
          );
        }

        setAllDoctors(prev =>
          prev.filter(d => d.id !== activeDoctor.id).sort((a, b) => a.name.localeCompare(b.name))
        );
        setTopDoctors(updatedTop);

        await reorderDoctors({ from_id: activeDoctor.id, to_id: overDoctor.id });
        toast.success("Doctor moved to Top 20!");
      } else if (isActiveInTop && isOverInTop) {
        // Reorder inside Top 20
        const oldIndex = topDoctors.findIndex(d => d.id === activeId);
        const newIndex = topDoctors.findIndex(d => d.id === overId);
        const reordered = arrayMove(topDoctors, oldIndex, newIndex);
        setTopDoctors(reordered);

        await reorderDoctors({ from_id: activeDoctor.id, to_id: overDoctor.id });
        toast.success("Top 20 order updated!");
      }
    } catch (err) {
      toast.error("Failed to update doctor order.");
    }
  };

  const DoctorRow = ({ doctor, onEdit, onRemove }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
    } = useSortable({ id: doctor.id });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      cursor: "move",
    };

    return (
      <TableRow ref={setNodeRef} style={style} hover>
        <TableCell {...attributes} {...listeners}>
          {/* Only this cell is draggable */}
          {doctor.id}
        </TableCell>
        <TableCell>{doctor.display_order}</TableCell>
        <TableCell>{doctor.name_prefix} {doctor.name}</TableCell>
        <TableCell>{doctor.speciality}</TableCell>
        <TableCell>
          <Button
            onClick={() => onEdit && onEdit(doctor.id)}
            size="small"
            variant="outlined"
          >
            Edit
          </Button>
          <Button
            onClick={() => setDeleteDoctorId(doctor.id)}
            size="small"
            variant="outlined"
            color="error"
            style={{ marginLeft: 8 }}
          >
            Trash
          </Button>
          {/* {onRemove && (
            <Button
              onClick={() => onRemove(doctor.id)}
              size="small"
              variant="text"
              color="warning"
              style={{ marginLeft: 8 }}
            >
              Remove
            </Button>
          )} */}
        </TableCell>
      </TableRow>
    );
  };

  // Handle edit button click
  const handleEdit = async (id) => {
    try {
      const response = await editDoctor(id);
      console.log("here is data of Doctor", response.data);
      const data = response.data;
      const schedule = data.opd_schedules?.[0] || {};
      console.log("here is schedule", schedule);
      const OPDschedule = response.data.opd_schedules?.[0] || {};

      if (response?.data) {
        setEditDoctorItem({
          // ...response.data,
          id: response.data.id || "",
          name_prefix: response.data.name_prefix || "",
          name: response.data.name || "",
          slug: response.data.slug || "",
          description: response.data.description || "",
          // speciality_id: response.data.speciality_id || "",
          speciality_ids: response.data.speciality_ids || [],
          education: response.data.education || "",
          img_path: response.data.img_path || "",
          banner_img: response.data.banner_img || "",
          experience: response.data.experience || "",
          designation: response.data.designation || "",
          special_interest: response.data.special_interest || "",
          video_link: response.data.video_link || "",
          display_order: response.data.display_order || "",
          department: response.data.department || "",
          // days: response.data.opdSchedule?.days || "",
          // timing: response.data.opdSchedule?.timing || "",
          days: OPDschedule.days || "",
          timing: OPDschedule.timing || "",


          meta_title: response.data.meta_title || "",
          meta_description: response.data.meta_description || "",
          meta_keyword: response.data.meta_keywords || "",
          custom_scripts: response.data.custom_scripts || "",
          seo_title: response.data.seo_title || "",
          canonical_link: response.data.canonical_link || "",
          og_locale: response.data.og_locale || "",
          og_site_name: response.data.og_site_name || "",
          og_image_width: response.data.og_image_width || "",
          og_image_height: response.data.og_image_height || "",
          og_image_type: response.data.og_image_type || "",
          article_modified_time: response.data.article_modified_time || "",
          og_title: response.data.og_title || "",
          og_description: response.data.og_description || "",
          og_type: response.data.og_type || "",
          og_url: response.data.og_url || "",
          og_image: response.data.og_image || "",
          twitter_card: response.data.twitter_card || "",
          twitter_title: response.data.twitter_title || "",
          twitter_description: response.data.twitter_description || "",
          twitter_site: response.data.twitter_site || "",
          twitter_image: response.data.twitter_image || "",
          // days: schedule.days || "",
          // start_time: schedule.start_time || "",
          // end_time: schedule.end_time || "",
          // appointment_status: schedule.appointment_status || "",
          status: response.data.status || "",
          file: response.data.file || "",
        });
      } else {
        toast.error("Failed to fetch doctor details.");
      }
    } catch (err) {
      toast.error("Failed to load doctor data for editing.");
    }
  };

  // Handle save edit
  const handleSaveEdit = async () => {
    setLoadingAction(true);

    const formData = new FormData();

    // const schedule = editDoctorItem.opd_schedules?.[0] || {};

    formData.append("name", editDoctorItem.name);
    formData.append("slug", editDoctorItem.slug || "");
    formData.append("description", editDoctorItem.description || "");
   // formData.append("speciality_id", editDoctorItem.speciality_id);
    (editDoctorItem.speciality_ids || []).forEach((id) => {
      formData.append("speciality_ids[]", id);
    });
    formData.append("education", editDoctorItem.education || "");
    formData.append("experience", editDoctorItem.experience?.toString() || "");
    formData.append("designation", editDoctorItem.designation || "");
    formData.append("special_interest", editDoctorItem.special_interest || "");
    formData.append('name_prefix', editDoctorItem.name_prefix || '');
    formData.append('department', editDoctorItem.department || '');
    formData.append('video_link', editDoctorItem.video_link || '');
    formData.append('days', editDoctorItem.days || '');
    formData.append('timing', editDoctorItem.timing || '');
    // formData.append("display_order", editDoctorItem.display_order?.toString() || "0");
    if (editDoctorItem.display_order !== "") {
      formData.append("display_order", parseInt(editDoctorItem.display_order));
    }

    formData.append("meta_title", editDoctorItem.meta_title || "");
    formData.append("meta_description", editDoctorItem.meta_description || "");
    formData.append("meta_keyword", editDoctorItem.meta_keyword || "");
    formData.append("custom_scripts", editDoctorItem.custom_scripts || "");
    formData.append("og_title", editDoctorItem.og_title || "");
    formData.append("og_description", editDoctorItem.og_description || "");
    formData.append("og_type", editDoctorItem.og_type || "");
    formData.append("og_locale", editDoctorItem.og_locale || "");
    formData.append("og_site_name", editDoctorItem.og_site_name || "");
    formData.append("og_image_width", editDoctorItem.og_image_width || "");
    formData.append("og_image_height", editDoctorItem.og_image_height || "");
    formData.append("og_image_type", editDoctorItem.og_image_type || "");
    formData.append(
      "article_modified_time",
      editDoctorItem.article_modified_time || ""
    );

    formData.append("canonical_link", editDoctorItem.canonical_link || "");
    formData.append("seo_title", editDoctorItem.seo_title || "");
    formData.append("og_url", editDoctorItem.og_url || "");
    formData.append("twitter_card", editDoctorItem.twitter_card || "");
    formData.append("twitter_title", editDoctorItem.twitter_title || "");
    formData.append(
      "twitter_description",
      editDoctorItem.twitter_description || ""
    );
    formData.append("twitter_site", editDoctorItem.twitter_site || "");
    // formData.append("days", editDoctorItem.days || "");
    // formData.append("start_time", editDoctorItem.start_time || "");
    // formData.append("end_time", editDoctorItem.end_time || "");
    formData.append(
      "appointment_status",
      editDoctorItem.appointment_status || ""
    );
    formData.append("status", editDoctorItem.status || "");

    if (editDoctorItem.img_path instanceof File) {
      formData.append("profile_picture", editDoctorItem.img_path);
    }
    if (editDoctorItem.og_image instanceof File) {
      formData.append("og_image", editDoctorItem.og_image);
    }
    if (editDoctorItem.file instanceof File) {
      formData.append("file", editDoctorItem.file);
    }
    if (editDoctorItem.banner_img instanceof File) {
      formData.append("banner_img", editDoctorItem.banner_img);
    }
    if (editDoctorItem.twitter_image instanceof File) {
      formData.append("twitter_image", editDoctorItem.twitter_image);
    }

    console.log("Form Data Values:");
    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }
    // const keysToCheck = ["img_path"];
    // for (let [key, value] of formData.entries()) {
    //   if (keysToCheck.includes(key)) {
    //     console.log(`${key}:`, value);
    //   }
    // }

    try {
      await updateDoctor(editDoctorItem.id, formData);
      // console.log("Updating doctor with ID:", editDoctorItem.id);
      // console.log("Update Doctor API response:", response);
      toast.success("Doctor updated successfully!");
      setDoctors((prev) =>
        prev.map((item) =>
          item.id === editDoctorItem.id
            ? {
              ...item,
              prefix: editDoctorItem.name_prefix,
              name: editDoctorItem.name,
              slug: editDoctorItem.slug,
              description: editDoctorItem.description,
             // speciality_id: editDoctorItem.speciality_id,
	      speciality_ids: editDoctorItem.speciality_ids,
              education: editDoctorItem.education,
              experience: editDoctorItem.experience,
              designation: editDoctorItem.designation,
              department: editDoctorItem.department,
              days: editDoctorItem.days,
              timing: editDoctorItem.timing,
              video_link: editDoctorItem.video_link,
              // display_order: editDoctorItem.display_order,
              meta_title: editDoctorItem.meta_title,
              meta_description: editDoctorItem.meta_description,
              meta_keyword: editDoctorItem.meta_keyword,
              custom_scripts: editDoctorItem.custom_scripts,
              seo_title: editDoctorItem.seo_title,
              canonical_link: editDoctorItem.canonical_link,
              og_locale: editDoctorItem.og_locale,
              og_site_name: editDoctorItem.og_site_name,
              og_image_width: editDoctorItem.og_image_width,
              og_image_height: editDoctorItem.og_image_height,
              og_image_type: editDoctorItem.og_image_type,
              article_modified_time: editDoctorItem.article_modified_time,
              og_title: editDoctorItem.og_title,
              og_description: editDoctorItem.og_description,
              og_type: editDoctorItem.og_type,
              og_url: editDoctorItem.og_url,
              twitter_card: editDoctorItem.twitter_card,
              twitter_title: editDoctorItem.twitter_title,
              twitter_description: editDoctorItem.twitter_description,
              twitter_site: editDoctorItem.twitter_site,
              twitter_image: editDoctorItem.twitter_image,
              // days: editDoctorItem.days,
              // start_time: editDoctorItem.start_time,
              // end_time: editDoctorItem.end_time,
              // status: editDoctorItem.status,
              file: editDoctorItem.file,
              // appointment_status: editDoctorItem.appointment_status,
              img_path: editDoctorItem.img_path,
              banner_img: editDoctorItem.banner_img,
              og_image: editDoctorItem.og_image,
            }
            : item
        )
      );
      setEditDoctorItem(null);
    } catch (err) {
      toast.error("An error occurred while saving changes.");
    } finally {
      setLoadingAction(false);
    }
  };

  // Handle delete button click
  const handleDelete = async (id) => {
    setLoadingAction(true);
    try {
      const response = await trashDoctor(id);
      if (response && response.status === "true") {
        toast.success("Doctor deleted successfully!");
        setDoctors((prev) => prev.filter((item) => item.id !== id));
        setDeleteDoctorId(null);
      } else {
        toast.error("Failed to delete doctor.");
      }
    } catch (err) {
      toast.error("An error occurred while deleting the doctor.");
    } finally {
      setLoadingAction(false);
    }
  };
  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/&/g, " ")
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-");
  };

  const stripHtml = (html) => {
    if (typeof html !== "string") return "";
    return html.replace(/<[^>]+>/g, "");
  };

  const columns = [
    { field: "id", headerName: "ID", width: 50 },
    { field: "name_prefix", headerName: "Prefix", width: 50 },
    { field: "name", headerName: "Name", width: 200 },
    { field: "speciality", headerName: "Speciality", width: 200 },
    { field: "description", headerName: stripHtml("Description"), width: 250 },
    // { field: "department", headerName: "Department", width: 200 },
    // { field: "status", headerName: "Status", width: 150 },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      renderCell: (params) => (
        <Box>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => handleEdit(params.row.id)}
          >
            Edit
          </Button>
          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={() => setDeleteDoctorId(params.row.id)}
            style={{ marginLeft: "8px" }}
          >
            Trash
          </Button>
        </Box>
      ),
    },
  ];  
  
     const filteredTopDoctors = topDoctors.filter((doctor) =>
    doctor.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    doctor.speciality_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredRemainingDoctors = remainingDoctors.filter((doctor) =>
    doctor.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    doctor.speciality_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box m="20px">
      <ToastContainer />
      <Typography variant="h4" gutterBottom>
        Doctors List
      </Typography>

      <TextField
        fullWidth
        label="Search doctors by name or specialty"
        variant="outlined"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: '20px' }}
      />

      {/* <Paper elevation={2} sx={{ marginTop: 2 }}>
        <Typography variant="h5" sx={{ padding: 2 }}>
          Top 20 Doctors (Drag to Reorder)
        </Typography>

        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
          <div ref={setNodeRef}>
            <SortableContext items={topDoctors.map((d) => d.id)} strategy={verticalListSortingStrategy}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Display Order</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Speciality</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {topDoctors.map((doctor) => (
                    <DoctorRow key={doctor.id} doctor={doctor} onEdit={handleEdit} onRemove={(id) => {
                      setTopDoctors(prev => prev.filter(d => d.id !== id));
                      toast.info("Doctor removed from Top 20");
                    }} />
                  ))}
                </TableBody>
              </Table>
            </SortableContext>
          </div>
        </DndContext>
      </Paper>

      <Paper elevation={2} sx={{ marginTop: 4 }}>
        <Typography variant="h5" sx={{ padding: 2 }}>
          All Doctors (Drag to Top 20)
        </Typography>
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
          <div ref={setAllNodeRef}>
            <SortableContext items={remainingDoctors.map((d) => d.id)} strategy={verticalListSortingStrategy}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell></TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Speciality</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {remainingDoctors.map((doctor) => (
                    <DoctorRow key={doctor.id} doctor={doctor} onEdit={handleEdit} />
                  ))}
                </TableBody>
              </Table>
            </SortableContext>
          </div>
        </DndContext>
      </Paper> */}

      <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        {/* TOP 20 DOCTORS TABLE */}
        <Paper elevation={2} sx={{ marginTop: 2 }}>
          <Typography variant="h5" sx={{ padding: 2 }}>
            Top 20 Doctors (Drag to Reorder)
          </Typography>
          <div ref={setNodeRef}>
	  {/*  <SortableContext items={topDoctors.map((d) => d.id)} strategy={verticalListSortingStrategy}>  */}
	  <SortableContext items={filteredTopDoctors.map((d) => d.id)} strategy={verticalListSortingStrategy}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Display Order</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Speciality</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
	  {/* {topDoctors.map((doctor) => ( */}
	  {filteredTopDoctors.map((doctor) => (
                    <DoctorRow
                      key={doctor.id}
                      doctor={doctor}
                      onEdit={handleEdit}
                      onRemove={(id) => {
                        setTopDoctors((prev) => prev.filter((d) => d.id !== id));
                        toast.info("Doctor removed from Top 20");
                      }}
                    />
                  ))}
                </TableBody>
              </Table>
            </SortableContext>
          </div>
        </Paper>

        {/* ALL DOCTORS TABLE */}
        <Paper elevation={2} sx={{ marginTop: 4 }}>
          <Typography variant="h5" sx={{ padding: 2 }}>
            All Doctors (Drag to Top 20)
          </Typography>
          <div ref={setAllNodeRef}>
	  {/*  <SortableContext items={remainingDoctors.map((d) => d.id)} strategy={verticalListSortingStrategy}> */}
	  <SortableContext items={filteredRemainingDoctors.map((d) => d.id)} strategy={verticalListSortingStrategy}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell></TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Speciality</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
	  {/*  {remainingDoctors.map((doctor) => (  */}
	  {filteredRemainingDoctors.map((doctor) => (
                    <DoctorRow key={doctor.id} doctor={doctor} onEdit={handleEdit} />
                  ))}
                </TableBody>
              </Table>
            </SortableContext>
          </div>
        </Paper>
      </DndContext>

      {/* {loading ? (
        <CircularProgress />
      ) : (
        <DataGrid
          rows={doctors.filter((doc) =>
            `${doc.name_prefix || ""} ${doc.name || ""} ${doc.speciality || ""}`
              .toLowerCase()
              .includes(searchTerm.toLowerCase())
          )}
          columns={columns}
          autoHeight
        />
      )} */}

      {/* Edit Dialog */}
      {editDoctorItem && (
        <Dialog open onClose={() => setEditDoctorItem(null)}>
          <DialogTitle>Edit Doctor</DialogTitle>
          <DialogContent>
            <Typography variant="body1">Name Prefix</Typography>
            {/* <FormControl fullWidth variant="outlined">
              <InputLabel>Select Prefix</InputLabel>
              <Select
                name="name_prefix"
                value={editDoctorItem.name_prefix || ''}
                onChange={(e) => setEditDoctorItem({ ...editDoctorItem, name_prefix: e.target.value })}
                label="Select Prefix"
              >
                <MenuItem value="">
                  <em>Select Prefix</em>
                </MenuItem>
                {["Dr.", "Prof.", "Mr.", "Ms.", "Mrs."].map(prefix => (
                  <MenuItem key={prefix} value={prefix}>
                    {prefix}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
            <TextField
              fullWidth
              margin="normal"
              label="Name Prefix"
              name="name_prefix"
              value={editDoctorItem.name_prefix || ""}
             // onChange={(e) =>
             //   setEditDoctorItem((prev) => ({
             //     ...prev,
            //      name_prefix: e.target.value,
            //    }))
            //  }
	      onChange={(e) =>
                setEditDoctorItem((prev) => {
                  const updated = { ...prev, name_prefix: e.target.value };
                  const fullName = `${updated.name_prefix} ${updated.name}`.trim();
                  updated.slug = generateSlug(fullName);
                  return updated;
                })
              }
            />

            <TextField
              fullWidth
              margin="normal"
              label="Name"
              value={editDoctorItem.name}
              required
             //  onChange={(e) => {
             //   const name = e.target.value;
             //   setEditDoctorItem({
             //     ...editDoctorItem,
             //     name,
             //     slug: generateSlug(name),
             //   });
            //  }}
	     onChange={(e) => {
                const updated = { ...editDoctorItem, name: e.target.value };
                const fullName = `${updated.name_prefix} ${updated.name}`.trim();
                updated.slug = generateSlug(fullName);
                setEditDoctorItem(updated);
              }}
            />
            <TextField
              fullWidth
              margin="normal"
              label="slug"
              value={editDoctorItem.slug}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  slug: e.target.value,
                }))
              }
            />

            <Typography variant="body1">Description</Typography>
            {/* <ReactQuill
              theme="snow"
              value={editDoctorItem.description}
              onChange={(value) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  description: value,
                }))
              }
              style={{ height: "200px", marginBottom: "50px" }}
            /> */}
            <CKEditorField
            value={editDoctorItem.description}
            onChange={(data) => setEditDoctorItem((prev) => ({ ...prev, description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=doctors`}
          />

            <Typography variant="body1">Education</Typography>
            {/* <ReactQuill
              theme="snow"
              value={editDoctorItem.education}
              onChange={(value) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  education: value,
                }))
              }
              style={{ height: "200px", marginBottom: "50px" }}
            /> */}
            <CKEditorField
            value={editDoctorItem.education}
            onChange={(data) => setEditDoctorItem((prev) => ({ ...prev, education: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=doctors`}
          />

            <TextField
              fullWidth
              margin="normal"
              label="experience"
              name="experience"
              type="number"
              value={editDoctorItem.experience?.toString() || ""}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  experience: e.target.value,
                }))
              }
            />

            {/* <TextField
              fullWidth
              margin="normal"
              label="Speciality ID"
              type="number"
              value={editDoctorItem.speciality_id}
              required
              onChange={(e) =>
                setEditDoctorItem({
                  ...editDoctorItem,
                  speciality_id: e.target.value,
                })
              }
            /> */}
            {/* <FormControl fullWidth margin="normal">
              <InputLabel id="speciality-label">Speciality</InputLabel>
              <Select
                labelId="speciality-label"
                value={editDoctorItem.speciality_id}
                onChange={(e) =>
                  setEditDoctorItem((prev) => ({
                    ...prev,
                    speciality_id: e.target.value,
                  }))
                }
                label="Speciality"
              >
                <MenuItem value="">
                  <em>Select Speciality</em>
                </MenuItem>
                {specialtyOptions.map((specialty) => (
                  <MenuItem key={specialty.id} value={specialty.id}>
                    {specialty.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
            <FormControl fullWidth margin="normal">
              <InputLabel id="specialities-label">Specialities</InputLabel>
              <Select
                labelId="specialities-label"
                multiple
                value={editDoctorItem.speciality_ids || []}
                onChange={(e) =>
                  setEditDoctorItem((prev) => ({
                    ...prev,
                    speciality_ids: e.target.value,
                  }))
                }
                renderValue={(selected) =>
                  specialtyOptions
                    .filter((s) => selected.includes(s.id))
                    .map((s) => s.name)
                    .join(', ')
                }
              >
                {specialtyOptions.map((specialty) => (
                  <MenuItem key={specialty.id} value={specialty.id}>
                    <input
                      type="checkbox"
                      checked={editDoctorItem.speciality_ids?.includes(specialty.id)}
                      readOnly
                    />
                    <span style={{ marginLeft: 8 }}>{specialty.name}</span>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Typography variant="body1">Designation</Typography>
            {/* <ReactQuill
              theme="snow"
              value={editDoctorItem.designation}
              onChange={(value) => {
                setEditDoctorItem((prev) => ({ ...prev, designation: value }));
              }}
              style={{ height: "200px", marginBottom: "50px" }}
            /> */}
            <CKEditorField
            value={editDoctorItem.designation}
            onChange={(data) => setEditDoctorItem((prev) => ({ ...prev, designation: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=doctors`}
          />
            {/* Department */}
            <TextField
              fullWidth
              label="Department"
              name="department"
              value={editDoctorItem.department || ''}
              onChange={(e) => setEditDoctorItem({ ...editDoctorItem, department: e.target.value })}
              className="mb-4"
            />


            <Typography variant="body1">Areas of Expertise</Typography>
            {/* <ReactQuill
              theme="snow"
              value={editDoctorItem.special_interest}
              onChange={(value) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  special_interest: value,
                }))
              }
              modules={{
                toolbar: [
                  [{ list: "ordered" }, { list: "bullet" }],
                  ["bold", "italic", "underline"],
                  ["link"],
                  ["clean"]
                ],
              }}
              formats={["list", "bullet", "bold", "italic", "underline", "link"]}
              style={{ height: "200px", marginBottom: "50px" }}
            /> */}
            <CKEditorField
            value={editDoctorItem.special_interest}
            onChange={(data) => setEditDoctorItem((prev) => ({ ...prev, special_interest: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=doctors`}
          />
            <TextField
              fullWidth
              label="Video Links"
              name="video_link"
              value={editDoctorItem.video_link}
              onChange={(e) =>
                setEditDoctorItem({ ...editDoctorItem, video_link: e.target.value })
              }
            />

            <TextField
              fullWidth
              margin="normal"
              label="Display Order"
              name="display_order"
              type="number"
              value={editDoctorItem.display_order || ""}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  display_order: e.target.value,
                }))
              }
            />

            <div className="col-span-1 md:col-span-2">
              <Typography variant="body1">OPD Days</Typography>
              {/* <ReactQuill
                theme="snow"
                value={editDoctorItem.days || ""}
                // onChange={(value) => setEditDoctorItem({ ...editDoctorItem, days: value })}
                onChange={(value) =>
                  setEditDoctorItem((prev) => ({
                    ...prev,
                    days: value,
                  }))
                }
                className="mb-4 bg-white"
                style={{ height: "200px", marginBottom: "60px" }}
              /> */}
              <CKEditorField
            value={editDoctorItem.days}
            onChange={(data) => setEditDoctorItem((prev) => ({ ...prev, days: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=doctors`}
          />
            </div>

            {/* OPD Timings */}
            <div className="col-span-1 md:col-span-2">
              <Typography variant="body1">OPD Timings</Typography>
              {/* <ReactQuill
                theme="snow"
                value={editDoctorItem.timing || ""}
                onChange={(value) => setEditDoctorItem({ ...editDoctorItem, timing: value })}
                // value={timing}
                // onChange={setTiming}
                className="mb-4 bg-white"
                style={{ height: "200px", marginBottom: "60px" }}
              /> */}
              <CKEditorField
            value={editDoctorItem.timing}
            onChange={(data) => setEditDoctorItem((prev) => ({ ...prev, timing: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=doctors`}
          />
            </div>


            <TextField
              fullWidth
              margin="normal"
              label="Meta Title"
              name="meta_title"
              value={editDoctorItem.meta_title}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  meta_title: e.target.value,
                }))
              }
            />

            <Typography variant="body1">meta_description</Typography>
            {/* <ReactQuill
              theme="snow"
              value={editDoctorItem.meta_description}
              onChange={(value) => {
                setEditDoctorItem((prev) => ({
                  ...prev,
                  meta_description: value,
                }));
              }}
              style={{ height: "200px", marginBottom: "60px" }}
            /> */}
            <CKEditorField
            value={editDoctorItem.meta_description}
            onChange={(data) => setEditDoctorItem((prev) => ({ ...prev, meta_description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=doctors`}
          />

            <TextField
              style={{ marginBottom: "30px" }}
              fullWidth
              margin="normal"
              label="meta_keywords"
              name="meta_keyword"
              value={editDoctorItem.meta_keyword}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  meta_keyword: e.target.value,
                }))
              }
            />
	      
	      {/* <Typography variant="body1">Custom_Scripts</Typography>
            <ReactQuill
              theme="snow"
              value={editDoctorItem.custom_scripts}
              onChange={(value) => {
                setEditDoctorItem((prev) => ({
                  ...prev,
                  custom_scripts: value,
                }));
              }}
              style={{ height: "200px", marginBottom: "50px" }}
            />  */}
             <TextField
              label="Custom Scripts"
              name="custom_scripts"
              value={editDoctorItem.custom_scripts}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({ ...prev, custom_scripts: e.target.value }))
              }
              fullWidth
              multiline
              minRows={10}
              maxRows={30}
              variant="outlined"
              style={{ marginBottom: "60px" }}
              placeholder={`Paste raw script here. Example:
              <script type="application/ld+json">
              { "jsonld": "data" }
              </script>`}
            />

            <TextField
              fullWidth
              margin="normal"
              label="seo_title"
              name="seo_title"
              value={editDoctorItem.seo_title}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  seo_title: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              margin="normal"
              label="canonical_link"
              name="canonical_link"
              value={editDoctorItem.canonical_link}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  canonical_link: e.target.value,
                }))
              }
            />

            <TextField
              fullWidth
              margin="normal"
              label="og_title"
              name="og_title"
              value={editDoctorItem.og_title}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  og_title: e.target.value,
                }))
              }
            />
            <Typography variant="body1">og_description</Typography>
            {/* <ReactQuill
              theme="snow"
              value={editDoctorItem.og_description}
              onChange={(value) => {
                setEditDoctorItem((prev) => ({
                  ...prev,
                  og_description: value,
                }));
              }}
              style={{ height: "200px", marginBottom: "60px" }}
            /> */}
            <CKEditorField
            value={editDoctorItem.og_description}
            onChange={(data) => setEditDoctorItem((prev) => ({ ...prev, og_description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=doctors`}
          />

            <TextField
              fullWidth
              margin="normal"
              label="og_type"
              name="og_type"
              value={editDoctorItem.og_type}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  og_type: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              margin="normal"
              label="og_url"
              name="og_url"
              value={editDoctorItem.og_url}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  og_url: e.target.value,
                }))
              }
            />

            <TextField
              fullWidth
              margin="normal"
              label="og_locale"
              name="og_locale"
              value={editDoctorItem.og_locale}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  og_locale: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              margin="normal"
              label="og_site_name"
              name="og_site_name"
              value={editDoctorItem.og_site_name}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  og_site_name: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              margin="normal"
              label="og_image_width"
              name="og_image_width"
              value={editDoctorItem.og_image_width}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  og_image_width: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              margin="normal"
              label="og_image_height"
              name="og_image_height"
              value={editDoctorItem.og_image_height}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  og_image_height: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              margin="normal"
              label="og_image_type"
              name="og_image_type"
              value={editDoctorItem.og_image_type}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  og_image_type: e.target.value,
                }))
              }
            />
            <Typography variant="body1">Article Modified Time</Typography>
            <TextField
              fullWidth
              margin="normal"
              // label="article_modified_time"
              type="datetime-local"
              name="article_modified_time"
              value={editDoctorItem.article_modified_time}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  article_modified_time: e.target.value,
                }))
              }
            />

            <TextField
              fullWidth
              margin="normal"
              label="twitter_card"
              name="twitter_card"
              value={editDoctorItem.twitter_card}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  twitter_card: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              margin="normal"
              label="twitter_title"
              name="twitter_title"
              value={editDoctorItem.twitter_title}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  twitter_title: e.target.value,
                }))
              }
            />
            <Typography variant="body1">Twitter Description</Typography>
            {/* <ReactQuill
              theme="snow"
              value={editDoctorItem.twitter_description}
              onChange={(value) => {
                setEditDoctorItem((prev) => ({
                  ...prev,
                  twitter_description: value,
                }));
              }}
              style={{ height: "200px", marginBottom: "60px" }}
            /> */}
            <CKEditorField
            value={editDoctorItem.twitter_description}
            onChange={(data) => setEditDoctorItem((prev) => ({ ...prev, twitter_description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=doctors`}
          />
            <TextField
              fullWidth
              margin="normal"
              label="twitter_site"
              name="twitter_site"
              value={editDoctorItem.twitter_site}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  twitter_site: e.target.value,
                }))
              }
            />

            {/* <TextField
              margin="normal"
              fullWidth
              label="days"
              name="days"
              value={editDoctorItem.days}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  days: e.target.value,
                }))
              }
            />

            <TextField
              margin="normal"
              fullWidth
              label="start_time"
              name="start_time"
              type="time"
              value={editDoctorItem.start_time}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  start_time: e.target.value,
                }))
              }
            />

            <TextField
              margin="normal"
              fullWidth
              label="end_time"
              name="end_time"
              type="time"
              value={editDoctorItem.end_time}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  end_time: e.target.value,
                }))
              }
            />
            <TextField
              margin="normal"
              fullWidth
              label="appointment_status"
              name="appointment_status"
              value={editDoctorItem.appointment_status}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  appointment_status: e.target.value,
                }))
              }
            />

            <TextField
              margin="normal"
              fullWidth
              label="status"
              name="status"
              value={editDoctorItem.status}
              onChange={(e) =>
                setEditDoctorItem((prev) => ({
                  ...prev,
                  status: e.target.value,
                }))
              }
            /> */}

            <Typography variant="body1" mt={2}>
              Profile Picture
            </Typography>
            {editDoctorItem.img_path && (
              <Box mt={2} mb={2} textAlign="center">
                <img
                  src={
                    editDoctorItem.img_path instanceof File
                      ? URL.createObjectURL(editDoctorItem.img_path)
                      : `${baseImage_path}/${editDoctorItem.img_path}`
                  }
                  alt=""
                  style={{
                    width: "150px",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                />
              </Box>
            )}
            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                setEditDoctorItem({
                  ...editDoctorItem,
                  img_path:
                    e.target.files.length > 0
                      ? e.target.files[0]
                      : editDoctorItem.img_path,
                })
              }
            />

            <Typography variant="body1" mt={2}>
              Banner_img
            </Typography>
            {editDoctorItem.banner_img && (
              <Box mt={6} mb={2} textAlign="center">
                <img
                  src={
                    editDoctorItem.banner_img instanceof File
                      ? URL.createObjectURL(editDoctorItem.banner_img)
                      : `${baseImage_path}/${editDoctorItem.banner_img}`
                  }
                  alt="Specialty"
                  style={{
                    width: "150px",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                />
              </Box>
            )}
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                setEditDoctorItem({
                  ...editDoctorItem,
                  banner_img:
                    e.target.files.length > 0
                      ? e.target.files[0]
                      : editDoctorItem.banner_img,
                });
              }}
            />

            <Typography variant="body1" mt={2}>
              Og_Image
            </Typography>
            {editDoctorItem.og_image && (
              <Box mt={6} mb={2} textAlign="center">
                <img
                  src={
                    editDoctorItem.og_image instanceof File
                      ? URL.createObjectURL(editDoctorItem.og_image)
                      : `${baseImage_path}/${editDoctorItem.og_image}`
                  }
                  alt="Specialty"
                  style={{
                    width: "150px",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                />
              </Box>
            )}
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                setEditDoctorItem({
                  ...editDoctorItem,
                  og_image:
                    e.target.files.length > 0
                      ? e.target.files[0]
                      : editDoctorItem.og_image,
                });
              }}
            />

            <Typography variant="body1" mt={2}>
              twitter image
            </Typography>
            {editDoctorItem.twitter_image && (
              <Box mt={6} mb={2} textAlign="center">
                <img
                  src={
                    editDoctorItem.twitter_image instanceof File
                      ? URL.createObjectURL(editDoctorItem.twitter_image)
                      : `${baseImage_path}/${editDoctorItem.twitter_image}`
                  }
                  alt="Specialty"
                  style={{
                    width: "150px",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                />
              </Box>
            )}
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                setEditDoctorItem({
                  ...editDoctorItem,
                  twitter_image:
                    e.target.files.length > 0
                      ? e.target.files[0]
                      : editDoctorItem.twitter_image,
                });
              }}
            />

            <Typography variant="body1" mt={2}>
              File
            </Typography>
            {editDoctorItem.file && (
              <Box mt={6} mb={2} textAlign="center">
                <img
                  src={
                    editDoctorItem.file instanceof File
                      ? URL.createObjectURL(editDoctorItem.file)
                      : `${baseImage_path}/${editDoctorItem.file}`
                  }
                  alt="Specialty"
                  style={{
                    width: "150px",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                />
              </Box>
            )}
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                setEditDoctorItem({
                  ...editDoctorItem,
                  file:
                    e.target.files.length > 0
                      ? e.target.files[0]
                      : editDoctorItem.file,
                });
              }}
            />

            {/* <Button variant="contained" component="label">
              Upload Profile Picture
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={(e) =>
                  setEditDoctorItem({
                    ...editDoctorItem,
                    img_path: e.target.files[0],
                  })
                }
              />
            </Button> */}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setEditDoctorItem(null)}
              variant="outlined"
              style={{ fontWeight: "bold", backgroundColor: "grey" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveEdit}
              disabled={loadingAction}
            >
              {loadingAction ? <CircularProgress size={24} /> : "Save"}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Delete Confirmation Dialog */}
      {deleteDoctorId && (
        <Dialog open onClose={() => setDeleteDoctorId(null)}>
          <DialogTitle>Delete Confirmation</DialogTitle>
          <DialogContent>
            Are you sure you want to delete this doctor?
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setDeleteDoctorId(null)}
              variant="outlined"
              style={{ fontWeight: "bold", backgroundColor: "grey" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => handleDelete(deleteDoctorId)}
              disabled={loadingAction}
            >
              {loadingAction ? <CircularProgress size={24} /> : "Confirm"}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      <RestoreDoctors />
    </Box>
  );
};

export default ListDoctors;
